// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sktA","toggle":"styles_toggle__MlIT9","preview":"styles_preview__3TmpR"};